import { isFeatureEnabled } from '@/common/feature'

/**
 * 是否开启vip等级保级feature
 * @returns
 */
export default function getIsSupportLevelProtection(): boolean {
  return !!isFeatureEnabled('vipLevelProtection')
}
